<template>
  <div @click="handleOnlineListen" class="online-listen-comp">
    <slot :opening="opening">
      <el-button :type="buttonType" :disabled="disabled">{{ showText }}</el-button>
    </slot>
  </div>
</template>

<script>
import Player from '@/components/Player'

export default {
  name: 'OnlineListen',
  components: {
    Player, // eslint-disable-line
  },
  props: {
    showText: {
      type: String,
      default: '在线试听'
    },
    buttonType: {
      type: String,
      default: 'text'
    },
    media: {
      type: Object,
      default() {
        return null
      }
    },
    trackName: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    transcode: {
      type: Boolean,
      default: false
    },
    trackKey: {
      type: String,
      default: 'track'
    }
  },
  data() {
    return {
      opening: false
    }
  },
  beforeDestroy() {
    this.$notifyCom && this.$notifyCom.close()
  },
  methods: {

    /**
     * @param {Object} media - 后端返回的音频文件对象, 主要值有
     * @param {String} media.mediaUrl - 音频 cos 完整地址
     */
    async handleOnlineListen() {
      const media = this.media
      this.$notifyCom && this.$notifyCom.close()
      if (media && media.mediaUrl) {
        const h = this.$createElement

        this.opening = true
        this.$notifyCom = this.$notify({
          title: `试听(歌曲：${media[this.trackKey] || ''} - ${this.trackName})`,
          message: h('player', {
            props: {
              howlerData: { src: [media.mediaUrl] },
              type: media.fileType,
              transcode: this.transcode,
              mediaId: media.mediaId
            },
            attrs: {
              style: 'width: 330px;'
            }
          }),
          position: 'bottom-right',
          type: 'info',
          customClass: 'online-listen',
          style: 'width: 200px',
          duration: 0
        })
      } else {
        this.$notifyCom = this.$notify({
          title: '提示',
          type: 'warning',
          duration: 5000,
          position: 'bottom-right',
          message: '无音频文件'
        })
      }
    },

    listenClose() {
      this.opening = false
      this.$emit('listen-close')
    }
  }
}
</script>
<style>
.online-listen {
  width: 400px;
}
.online-listen-comp {
  display: inline-block;
}
</style>
